import * as React from 'react';
import { inject, observer } from 'mobx-react';

import { AnalyticsStore, QueryRoute, RouteStore } from 'bernie-core';
import { Layer } from 'bernie-view';

import { FindAnswersTakeover } from './find-answers-takeover';
import { classNames } from 'uitk-react-utils';
import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';
import { CurrentHotelStore } from 'stores/current-hotel-store';
import { HisTopEntry } from 'components/infosite/find-answers/his-top-entry';
import { HisBottomEntry } from 'components/infosite/find-answers/his-bottom-entry';
import { ReviewEntry } from 'components/infosite/find-answers/review-entry';

export interface FindAnswersProps extends LocalizedComponentProps {
  routeStore?: RouteStore;
  analytics?: AnalyticsStore;
  currentHotel?: CurrentHotelStore;
  topPadding?: boolean;
  reviewEntry?: boolean;
}

export interface FindAnswersState {
  jsEnabled: boolean;
}

@withLocalization
@inject('routeStore', 'analytics', 'currentHotel')
@observer
export class FindAnswersCta extends React.Component<FindAnswersProps, FindAnswersState> {
  constructor(props) {
    super(props);
    this.onFindAnswersDismiss = this.onFindAnswersDismiss.bind(this);
    this.onFocus = this.onFocus.bind(this);

    this.state = {
      jsEnabled: false
    };
  }

  public componentDidMount() {
    this.setState({
      jsEnabled: true
    });
  }

  private onFindAnswersDismiss() {
    const { routeStore } = this.props;
    if (routeStore && typeof routeStore.goBack === 'function') {
      routeStore.goBack();
    }
  }

  private onFocus() {
    const { routeStore, analytics, reviewEntry } = this.props;
    if (analytics && typeof analytics.trackEvent === 'function') {
      const eventName = reviewEntry ? 'AskQuestion.FindAnswersReviewEntry' : 'AskQuestion.FindAnswersBottomEntry';
      analytics.trackEvent(eventName, 'Open Ask Question Form', {});
    }
    if (routeStore && typeof routeStore.updateSearch === 'function') {
      routeStore.updateSearch({ pwaDialogNested: 'findAnswers' });
    }
  }

  public render() {
    const { analytics, l10n, topPadding, reviewEntry, routeStore } = this.props;
    const { jsEnabled } = this.state;

    const listClasses = classNames('uitk-cell', {
      's-b-padding-six m-b-padding-six': reviewEntry,
      'uitk-type-center': !topPadding,
      'all-y-padding-zero': !reviewEntry
    });

    const linkClassNames = ['truncate'];
    if (!jsEnabled) {
      linkClassNames.push('is-disabled');
    }

    return (
      <React.Fragment>
        {reviewEntry && <ReviewEntry listClasses={listClasses} l10n={l10n} onFocus={this.onFocus} />}
        {!reviewEntry &&
          topPadding && (
            <HisTopEntry
              listClasses={listClasses}
              headerTitle={l10n.formatText('hotels.infosite.findAnswers.cta.title')}
              jsEnabled={jsEnabled}
              linkClassNames={linkClassNames}
              routeStore={routeStore}
              placeholder={l10n.formatText('hotels.infosite.findAnswers.cta.placeholder')}
            />
          )}
        {!reviewEntry &&
          !topPadding && (
            <HisBottomEntry
              listClasses={listClasses}
              headerTitle={l10n.formatText('hotels.infosite.findAnswers.cta.title')}
              jsEnabled={jsEnabled}
              placeholder={l10n.formatText('hotels.infosite.findAnswers.cta.placeholder')}
              onFocus={this.onFocus}
            />
          )}
        <QueryRoute search={undefined} query={{ pwaDialogNested: 'findAnswers' }} match={false}>
          <Layer id="infosite-find-answers" onDismiss={this.onFindAnswersDismiss}>
            <FindAnswersTakeover analytics={analytics} onDismiss={this.onFindAnswersDismiss} />
          </Layer>
        </QueryRoute>
      </React.Fragment>
    );
  }
}
